import { MapStateToProps, MapDispatchToProps } from 'react-redux';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { Props } from './AddDeviationsButton';
import {
  getCurrentStreamItems,
  getIsShowingAddDeviationsPopup,
} from '../../selectors';
import {
  addDeviations,
  showAddDeviationsPopup,
  hideAddDeviationsPopup,
} from '../../actions';

export type StateProps = Pick<
  Props,
  'currentDeviationIds' | 'isShowingAddDeviationsPopup'
>;
export type DispatchProps = Pick<
  Props,
  'addDeviations' | 'showAddDeviationsPopup' | 'hideAddDeviationsPopup'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => ({
  currentDeviationIds: getCurrentStreamItems(state),
  isShowingAddDeviationsPopup: getIsShowingAddDeviationsPopup(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  addDeviations,
  showAddDeviationsPopup,
  hideAddDeviationsPopup,
};

export default connectMediaStore(mapStateToProps, mapDispatchToProps);
